const en = {

    search:"Search",


    organization:"Organization",
    year:"Year",
    months:"Month",
    days:"Day",
    assessment:"Assessment",
    assessments:"Self-Assessment",
    self:"self",
    subordinate:"Subordinate-Assessment",

    staffID:"Staff ID",
    department:"Department",
    status:"Status",
    process:"Process",

    fullname:"FirstName-LastName",

    firstName:"FirstName",
    lastName:"LastName",
    position:"Position",
    remark:"Remark",
    startDate:"Start Date",
    yearsOfService:"Years of Service",
    staffTypes:"Staff types",
    competencyLevel:"Competency Level",

    reportStatus:"Assessment Status by Department",
    reportCc:"Core Competency Assessment Summary by Each CC",
    reportCompetency:"Core Competency Assessment Summary by Department ",


    save:"Save",
    send:"Send",
    unsend:"UnSend",
    reject:"Reject",
    remove:"Remove",

    LatestTime:"Latest time",

    idp: {

        title:"Individual Development Plan",
        round:"Evaluation Round B.E.",

        section1 : "Section 1: Personal Information",
        nameSurname : "Name - Surname",
        position : "Position",
        department : "Department",
        yearsofService : "Years of Service",
        supervisor : "Name of Immediate Supervisor",
        instructions : "Instructions",



        section2 :"Section 2: Individual Development Plan (to be completed with immediate supervisor)",
        note : ["1.The individual undergoing development shall identify the selected development methods and provide relevant details as specified, and subsequently reflect on the learning outcomes achieved after completing the development activities.","2. The immediate supervisor should monitor the behaviors or outcomes after the employee completes the individual development plan and report the development results in Section 3"],

        yourself:"Yourself",
        subordinate:"Subordinate",

        method:"Method",
        course:"Course",
        details:"Detail",
        period:"Period",
        budget: "Budget",
        learnedDeveloper:"Things learned from development",
        learned:"Learned",
        suggestions:"Suggestions",
        verification : "Verification",
        results : "Evaluation of results",


        dialog: {
            clear : "Comfirm Deletion",
            verification: "⚠️ Some development methods have not been approved, Confirm submission",
        }


    },

    idpReprot:{
        reportIDP:"สรุปผลประเมินแยกราย แผนพัฒนาบุคลากรรายบุคคล",
    },


    tooltip: {
        assessment:"Change Assessment",
        detail:"Detail"
    },

    faculty: "Faculty",

    agree:"Agree",
    disagree:"Disagree",

    gap:{
        found:"Gap Found",
        notFound:"No Gap",
    },

    orders : "Orders",


    parameter: {
        invalid : "Missing or invalid parameter"
    },


    reports:{
        member : "Member",
    }

}
export default en
